import React from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
export function BonusSection() {
  const bonuses = [{
    title: 'Kit de Emergencia Nocturna',
    desc: 'Árbol de decisión para saber qué hacer en cada despertar. Para usar en plena madrugada sin pensar.',
    value: '$8.000'
  }, {
    title: 'Planilla Maestra de Rutinas',
    desc: 'Workbook con plantillas por edad para ordenar el día y detectar patrones en 7 días.',
    value: '$10.000'
  }, {
    title: 'Guía de Calma y Sobreestimulación',
    desc: 'Protocolo para bajar el llanto y la sobrecarga en minutos. Con scripts para no colapsar.',
    value: '$9.000'
  }, {
    title: 'Diario de Sueño Emocional',
    desc: '30 días de registro del estado emocional del bebé y del cuidador. La herramienta que ningún otro kit incluye.',
    value: '$8.000'
  }, {
    title: 'Guía de Comunicación con el Pediatra',
    desc: 'Cómo describir el sueño, qué preguntar y cuándo consultar de urgencia.',
    value: '$9.000'
  }, {
    title: 'Mini Guía de Masajes Terapéuticos',
    desc: 'Técnicas táctiles para calmar, regular gases y preparar el cuerpo para el sueño.',
    value: '$9.000'
  }];
  return <section className="py-20 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto relative" data-id="element-19">
      <div className="absolute inset-0 bg-gold-500/5 blur-[100px] rounded-full pointer-events-none" data-id="element-20"></div>

      <div className="text-center mb-16 relative z-10" data-id="element-21">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-22">
          <div className="inline-flex items-center justify-center p-4 bg-gold-500/10 rounded-full mb-6" data-id="element-23">
            <Gift className="w-10 h-10 text-gold-400" data-id="element-24" />
          </div>
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-4" data-id="element-25">
            🎁 LOS 6 BONOS — SIEMPRE INCLUIDOS
          </h2>
        </motion.div>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 relative z-10" data-id="element-26">
        {bonuses.map((bonus, index) => <motion.div key={index} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: index * 0.1
      }} className="bg-navy-800/80 border border-navy-600 p-6 rounded-2xl relative overflow-hidden group" data-id="element-27">
            <div className="absolute top-0 right-0 bg-gold-500 text-navy-900 text-xs font-bold px-3 py-1 rounded-bl-lg z-10" data-id="element-28">
              BONO {index + 1}
            </div>

            <h4 className="text-xl font-bold text-white mb-3 pr-16 mt-2" data-id="element-29">
              {bonus.title}
            </h4>
            <p className="text-blue-100/80 text-sm mb-6 flex-grow" data-id="element-30">
              {bonus.desc}
            </p>

            <div className="flex items-center justify-between mt-auto pt-4 border-t border-navy-700" data-id="element-31">
              <span className="text-gray-400 line-through text-sm" data-id="element-32">
                {bonus.value}
              </span>
              <span className="text-green-400 font-bold" data-id="element-33">GRATIS</span>
            </div>
          </motion.div>)}
      </div>

      <motion.div initial={{
      opacity: 0,
      scale: 0.95
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6,
      delay: 0.4
    }} className="mt-16 text-center bg-navy-800/50 border border-gold-500/50 py-6 px-8 rounded-2xl max-w-2xl mx-auto relative z-10" data-id="element-34">
        <p className="text-xl md:text-2xl text-white" data-id="element-35">
          Valor total de los bonos:{' '}
          <span className="line-through text-gray-400" data-id="element-36">$53.000</span>{' '}
          <span className="text-gold-400 font-bold ml-2" data-id="element-37">
            → GRATIS con tu Kit
          </span>
        </p>
      </motion.div>
    </section>;
}